import React from 'react';
import styles from './WidgetLoading.module.css';

interface WidgetLoadingProps {
  dataTestId: string;
}

/** The placeholder a widget shows, on the Dashboard or a Launch Page, while its data loads. */
const WidgetLoading: React.FC<WidgetLoadingProps> = ({ dataTestId }) => (
  <div className={styles.loading} data-test-id={dataTestId} aria-busy="true" />
);

export { WidgetLoading };
